<template>
  <v-container fluid class="bill-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs color="primary">
          <v-tab :href="`#tab-bill`" class="mr-5">
            <v-icon class="mr-3">mdi-text-box-outline</v-icon>
            Bill
          </v-tab>
          <v-tab class="mr-5" :href="`#tab-items`" >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Items
          </v-tab>
          <v-tab :href="`#tab-files`" class="mr-5">
            <v-icon class="mr-3">mdi-file-pdf-box</v-icon>
            Files
          </v-tab>
          <v-tab-item :value="'tab-bill'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Bill</p>
                      <v-select
                        readonly
                        class="mb-4"
                        :items="billtype"
                        v-model="edit_bill.billtype"
                        v-on:change="onChangeBill($event, 'billtype')"
                        v-bind:error="errorindex == 0"
                        outlined
                        dense
                        placeholder="Type"
                        persistent-hint
                        single-line
                        hint="Please choose the bill type"
                      >
                      </v-select>
                      <v-menu
                        :readonly="isNotEditable"
                        ref="menu_billdate"
                        v-model="menu_billdate"
                        :close-on-content-click="false"
                        :return-value.sync="billdate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :readonly="isNotEditable"
                            outlined
                            dense
                            v-model="billdate"
                            label="Bill Date"
                            v-bind="attrs"
                            v-bind:value="billdate"
                            v-on:change="
                              onChangeBill($event, 'billdate')
                            "
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            hint="Please choose the bill date"
                            persistent-hint
                          >
                            ></v-text-field
                          >
                        </template>
                        <v-date-picker
                          :readonly="isNotEditable"
                          v-model="billdate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_billdate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              onChangeBill(
                                billdate,
                                'billdate'
                              );
                              $refs.menu_billdate.save(billdate);
                            "
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      <v-menu
                        ref="menu_billduedate"
                        v-model="menu_billduedate"
                        :close-on-content-click="false"
                        :return-value.sync="billduedate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            dense
                            v-model="billduedate"
                            label="Bill Due Date"
                            v-bind="attrs"
                            v-bind:value="billduedate"
                            v-on:change="
                              onChangeBill($event, 'billduedate')
                            "
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            hint="Please choose the bill due date"
                            persistent-hint
                          >
                            ></v-text-field
                          >
                        </template>
                        <v-date-picker
                          :readonly="isNotEditable"
                          v-model="billduedate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_billduedate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              onChangeBill(
                                billduedate,
                                'billduedate'
                              );
                              $refs.menu_billduedate.save(billduedate);
                            "
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      <v-select
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="locations.map(x => {return {text: x.locationname, value: x._id};})"
                        v-model="edit_bill.locationid"
                        v-on:change="onChangeBill($event, 'locationid')"
                        v-bind:error="errorindex == 6"
                        outlined
                        dense
                        placeholder="Location"
                        persistent-hint
                        single-line hint="Please choose the location">
                      </v-select>
                      <v-select
                        v-if="type=='rental'"
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="[
                          {text: 'None', value: null},
                          ...properties.map(x => {return {text: x.propertyname, value: x._id};})
                        ]"
                        v-model="edit_bill.propertyid"
                        v-on:change="onChangeBill($event, 'propertyid')"
                        v-bind:error="errorindex == 6"
                        outlined
                        dense
                        placeholder="Property"
                        persistent-hint
                        single-line hint="Please choose the property">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="['New', 'Pending', 'Completed']"
                        v-model="edit_bill.billstatus"
                        v-on:change="onChangeBill($event, 'billstatus')"
                        outlined
                        dense
                        placeholder="Status"
                        persistent-hint
                        single-line
                        hint="Please choose the status"
                      >
                      </v-select>
                      <v-switch
                        color="primary"
                        v-on:change="onChangeBill($event, 'isTaxable')"
                        v-model="edit_bill.isTaxable"
                        v-bind:value="edit_bill ? edit_bill.isTaxable : false"
                        hint="Taxable"
                        persistent-hint
                      ></v-switch>
                    </v-form>
                  </v-col>
                  <v-col v-if="initvalue.billtype=='Expense Bill'" cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-text-field
                        readonly
                        class="mb-4"
                        append-icon="mdi-magnify"
                        placeholder="Vendor Name"
                        single-line hint="Select the Vendor"
                        outlined
                        dense
                        @click:append="searchVendorDialog"
                        persistent-hint
                        v-model="edit_bill.billname"
                        v-bind:error="errorindex == 3"
                      >
                      </v-text-field>  
                      <v-textarea
                        :readonly="isNotEditable"
                        outlined
                        v-model="edit_bill.billaddress"
                        v-on:change="
                          onChangeBill($event, 'billaddress')
                        "
                        rows="2"
                        label="Address"
                        hint="please enter the vendor address"
                      ></v-textarea>
                      <v-text-field
                        :readonly="isNotEditable"
                        class="mb-4"
                        v-model="edit_bill.billphone"
                        v-on:change="
                          onChangeBill($event, 'billphone')
                        "
                        outlined
                        v-bind:error="errorindex == 11"
                        dense
                        placeholder="Phone"
                        persistent-hint
                        single-line
                        hint="Enter the phone"
                      >
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col v-if="initvalue.billtype=='Expense Bill'" cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        v-if="type=='service'"
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="departments.map(x => {return {text: x.departmentname, value: x._id};})"
                        v-model="edit_bill.departmentid"
                        v-on:change="onChangeBill($event, 'departmentid')"
                        v-bind:error="errorindex == 6"
                        outlined
                        dense
                        placeholder="Department"
                        persistent-hint
                        single-line hint="Please choose the department">
                      </v-select>
                      <v-select 
                        v-if="type=='service'"
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="[{text: 'None', value: null}, ...saleschannels.map(x => {return {text: x.channelname, value: x._id};})]"
                        v-model="edit_bill.channelid"
                        v-on:change="onChangeBill($event, 'channelid')"
                        v-bind:error="errorindex == 6"
                        outlined
                        dense
                        placeholder="Channel"
                        persistent-hint
                        single-line hint="Please choose the channel">
                      </v-select>
                      <v-select 
                        v-if="type=='rental'"
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="[{text: 'None', value: null}, ...regions.map(x => {return {text: x.regionname, value: x._id};})]"
                        v-model="edit_bill.regionid"
                        v-on:change="onChangeBill($event, 'regionid')"
                        v-bind:error="errorindex == 6"
                        outlined
                        dense
                        placeholder="Region"
                        persistent-hint
                        single-line hint="Please choose the region">
                      </v-select>
                      <v-select
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="billpayterms"
                        v-model="edit_bill.billpayterms"
                        v-on:change="onChangeBill($event, 'billpayterms')"
                        v-bind:error="errorindex == 5"
                        outlined
                        dense
                        placeholder="Pay Terms"
                        persistent-hint
                        single-line
                        hint="Please choose the pay terms"
                      >
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-text-field
                        :readonly="isNotEditable"
                        class="mb-4"
                        v-model="edit_bill.refnum"
                        v-on:change="
                          onChangeBill($event, 'refnum')
                        "
                        outlined
                        dense
                        placeholder="Ref Num"
                        persistent-hint
                        single-line
                        hint="Enter the invoice or ref num"
                      >
                      </v-text-field>

                      <v-select
                          :readonly="isNotEditable"
                          class="mb-4"
                          :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                          v-on:change="onChangeBill($event, 'primaryCurrency')"
                          v-bind:value="edit_bill.primaryCurrency"
                          v-bind:error="errorindex == 11"
                          outlined
                          dense
                          placeholder="Primary Currency"
                          persistent-hint
                          single-line hint="Please choose the primary currency">
                      </v-select>
                      <v-select
                          :readonly="isNotEditable"
                          class="mb-4"
                          :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                          v-on:change="onChangeBill($event, 'secondaryCurrency')"
                          v-bind:error="errorindex == 12"
                          v-bind:value="edit_bill.secondaryCurrency"
                          outlined
                          dense
                          placeholder="Secondary Currency"
                          persistent-hint
                          single-line hint="Please choose the secondary currency">
                      </v-select>
                      <v-text-field
                        :readonly="isNotEditable"
                          class="mb-4"
                          v-bind:value="edit_bill.currencyRate"
                          v-bind:error="errorindex == 13"
                          v-on:change="onChangeBill($event, 'currencyRate')"
                          outlined
                          dense
                          placeholder="Rate"
                          persistent-hint
                          single-line hint="Enter the currency rate">
                        </v-text-field>
                        <v-textarea
                          :readonly="isNotEditable"
                          v-model="edit_bill.billnote"
                          v-on:change="onChangeBill($event, 'billnote')"
                          outlined
                          rows=3
                          label="Note"
                          hint="please enter the note"
                      ></v-textarea>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/bill/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        :loading="isReceiving"
                        class="button-shadow"
                        color="primary"
                        @click="updateBill()"
                      >
                        Save
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-items'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row>
                  <v-col md="6">
                    <p class="text-h5">Items</p>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" lg="6" class="d-flex flex-end justify-md-end overflow-auto" align="right">
                    <v-btn
                      v-show="isEditable"
                      class="button-shadow mr-1"
                      color="success"
                      @click="isAddTransaction=true; new_transaction={}">
                      Add
                    </v-btn>
                    <v-btn
                      class="button-shadow mr-1"
                        to="/bill/list"
                        replace
                        color="primary"
                      >
                        Done
                    </v-btn>
                  </v-col>
                  </v-row>
                  <v-data-table
                    sort-by="transrank"
                    :headers="header_items"
                    :items="transactions"
                    :items-per-page="500"
                    :footer-props="footer"
                    class="elevation-0"
                  >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteTransaction" width="500">
                            <v-card>
                              <v-card-title> Delete this Item? </v-card-title>
                              <v-card-text>
                                {{ delete_transaction.itemdesc }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteTransaction = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteTransaction(delete_transaction)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.itemimage="{ item }">
                          <v-img
                            v-bind:lazy-src="item.itemimage"
                            min-width="50"
                            max-width="100"
                            v-bind:src="item.itemimage"
                          ></v-img>
                        </template>
                        <template v-slot:item.accountid="{ item }">
                          {{ accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountname'] : '' }}
                        </template>
                        <template v-slot:item.itemamount="{ item }">
                          {{ item.itemamount.toFixed(2) }}
                        </template>
                        <template v-slot:item.transdate="{ item }">
                          {{ item.transdate!=null ? new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            v-if="isEditable"
                            icon
                            color="primary"
                            @click="editTransactionDialog(item)"
                          >
                            <v-icon>mdi-pencil-outline</v-icon>
                          </v-btn>
                          <v-btn
                            v-if="isEditable"
                            icon
                            color="primary"
                            @click="deleteTransactionDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-files'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                        <v-col md="11">
                          <p class="text-h5">Files</p>
                        </v-col>
                        <v-col md="1">
                          <v-btn
                            class="button-shadow"
                            color="secondary"
                            @click="isUploadFile = true"
                          >
                            Add
                          </v-btn>
                        </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :headers="fileHeaders"
                        :items="files"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteFile" width="500">
                            <v-card>
                              <v-card-title> Delete this File? </v-card-title>
                              <v-card-text>
                                {{ deletefile.filename }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteFile = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteFile(deletefile)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.filetype="{ item }">
                            <a v-if="item.filetype=='pdf'" :href="item.fileurl" style="text-decoration: none !important;">
                              <v-icon 
                            size="50"
                            color="primary"
                            >
                              mdi-file-pdf-box
                            </v-icon></a>    
                        </template>
                        <template v-slot:item.filesize="{ item }">
                            {{ (item.filesize/1000).toFixed(0) + " KB"  }}    
                        </template>
                        <template v-slot:item.createdAt="{ item }">
                          {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}
                        </template>
                        <template v-slot:item.actions="{ item }">

                          <v-btn
                            icon
                            color="primary"
                            @click="deleteFileDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>

                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/bill/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isAddTransaction"
        persistent
        width="1000px"
        max-width="1000px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items=data_classes
                    v-model="accountclass"
                    outlined
                    dense
                    placeholder="Class"
                    persistent-hint
                    single-line hint="Please choose the class">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items=data_subclasses
                    v-model="accountsubclass"
                    outlined
                    dense
                    placeholder="Subclass"
                    persistent-hint
                    single-line hint="Please choose the subclass">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="accounts.filter(account=>account.accountsubclass==accountsubclass && account.accountsubtype=='Account').map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="new_transaction.accountid"
                    v-bind:error="errorindex == 11"
                    outlined
                    dense
                    placeholder="Account"
                    persistent-hint
                    single-line hint="Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="new_transaction.itemdesc"
                    v-bind:error="errorindex == 12"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="new_transaction.itemamount"
                    v-bind:error="errorindex == 13"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
                <v-col v-if="initvalue.billtype=='Month Expense Bill'" cols="12" md="4">
                  <v-menu
                    ref="menu_transdate"
                    v-model="menu_transdate"
                    :close-on-content-click="false"
                    :return-value.sync="new_transaction.transdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        dense
                        v-model="new_transaction.transdate"
                        label="Transaction Date"
                        v-bind="attrs"
                        v-bind:value="new_transaction.transdate"
                        v-bind:error="errorindex == 1"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please choose the transaction date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="new_transaction.transdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_transdate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_transdate.save(new_transaction.transdate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddTransaction=false; add_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="insertTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="1000px"
        max-width="1000px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items=data_classes
                    v-model="accountclass2"
                    outlined
                    dense
                    placeholder="Class"
                    persistent-hint
                    single-line hint="Please choose the class">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items=data_subclasses2
                    v-model="accountsubclass2"
                    outlined
                    dense
                    placeholder="Subclass"
                    persistent-hint
                    single-line hint="Please choose the subclass">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="accounts.filter(account=>account.accountsubclass==accountsubclass2 && account.accountsubtype=='Account').map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="edit_transaction.accountid"
                    outlined
                    dense
                    placeholder="Account"
                    persistent-hint
                    single-line hint="Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="edit_transaction.itemdesc"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.itemamount"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-menu
                    ref="menu_transdate_edit"
                    v-model="menu_transdate_edit"
                    :close-on-content-click="false"
                    :return-value.sync="edit_transaction.transdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        dense
                        v-model="edit_transaction.transdate"
                        label="Transaction Date"
                        v-bind="attrs"
                        v-bind:value="edit_transaction.transdate"
                        v-bind:error="errorindex == 1"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please choose the transaction date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="edit_transaction.transdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_transdate_edit = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_transdate_edit.save(edit_transaction.transdate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="updateTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isUploadFile"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Upload File</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                <v-file-input label="File input" v-model="upload.file" v-on:change="onChangeFile" accept=".pdf" />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="upload.filename"
                    label="File Name"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isUploadFile = false; upload.file=null; upload.filename=''"
            >
              Close
            </v-btn>
            <v-btn
              :disabled="upload.file==null"
              color="blue darken-1"
              text
              @click="uploadFile"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatStdDate } from '@/mixins/date';
import router from "@/Routes";

export default {
  data() {
    return {
      header_items: [
        { text: 'Date', value: 'transdate', width: '8%'},
        { text: 'Account', value: 'accountid', width: '30%'},
        { text: 'Description', value: 'itemdesc'},
        { text: 'Amount', value: 'itemamount', width: '10%'},
        { text: "Actions", value: "actions", sortable: false, width: '10%' },
      ],
      fileHeaders: [
        { text: "Type", value: "filetype" },
        { text: "Name", value: "filename" },
        { text: "Size", value: "filesize" },
        { text: "Created", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      classes: ['Cost of Good Sold', 'Administrative Expense', 'Operating Expense', 'Marketing Expense', 'Tax & Financing Expense', 'Factory & Production Expense', 'Debt & Loan', 'Overhead'],
      change_bill: {},
      edit_bill: {},
      
      deletefile: {},
      searchvendor: {},
      initvalue: {},
      edit_transaction: {},
      new_transaction: {},
      delete_transaction: {},

      upload: {filename: null,file: null},
      files: [],
      billtype: ["Expense Bill", "Month Expense Bill", ],
      billpayterms: ["Due on Receipt", "Credit 15 Days", "Credit 30 Days"],
      incoterms: ["FOB", "CIF", "Ex-works"],
      transactions: [],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      route: 0,


      type: null,
      menu_transdate: false,
      menu_transdate_edit: false,
      
      accountclass: null,
      accountclass2: null,
      accountsubclass: null,
      accountsubclass2: null,

      billdate: null,
      billduedate: null,
      menu_billdate: false,
      menu_billduedate: false,

      isRental: false,
      isEditTransaction: false,
      isAddTransaction: false,
      isUploadFile: false,
      isDeleteFile: false,
      isDeleteTransaction: false,    
      errorindex: undefined,
    };
  },
  computed: {
    ...mapState("Account", ["accounts"]),
    ...mapState("Bill", ["isReceiving"]),
    ...mapState("Location", ["locations"]),
    ...mapState("Department", ["departments"]),    
    ...mapState("SalesChannel", ["saleschannels"]),
    ...mapState("Property", ["properties"]),
    ...mapState("Region", ["regions"]),
    isNotEditable(){
      let result = ['New','Credit','Partial','Pending','Audit','Void'].indexOf(this.initvalue.billstatus) == -1;
      return result;
    },
    isEditable(){
      let result = ['New','Partial', 'Audit', 'Void'].indexOf(this.initvalue.billstatus) >= 0;
      console.log(result);
      return result;
    },
    data_classes(){
      let object = Object.groupBy(this.accounts.filter(x=>x.accountclass=='Asset' || x.accountclass=='Liability' || x.accountclass=='Expense' ), item => {
        return item.accountclass;
      });
      let result = Object.keys(object);
      return result;
    },
    data_subclasses(){
      let filter = this.accounts.filter(account=>account.accountclass==this.accountclass);
      let object = Object.groupBy(filter, item => {
        return item.accountsubclass;
      });
      let result = Object.keys(object);
      return result;
    },
    data_subclasses2(){
      let filter = this.accounts.filter(account=>account.accountclass==this.accountclass2);
      let object = Object.groupBy(filter, item => {
        return item.accountsubclass;
      });
      let result = Object.keys(object);
      return result;
    },
  },
  methods: {
    ...mapActions("Account", ["getAccountsRequest"]),
    ...mapActions("Bill", ["deleteBillTransactionRequest", "getBillRequest", "insertBillTransactionRequest", "updateBillRequest", "updateBillTransaction", "updateBillTrade",]),
    ...mapActions("File", ["insertRouteFile", "deleteFileRequest"]),
    ...mapActions("Location", ["getLocationsRequest"]),
    ...mapActions("Department", ["getDepartmentsRequest"]),
    ...mapActions("SalesChannel", ["getSalesChannelsRequest"]),
    ...mapActions("Property", ["getPropertiesRequest"]),
    ...mapActions("Region", ["getRegionsRequest"]),
    ...mapActions('SystemSetting', ["getSetting"]),
    checkError() {
      if (!this.accessname) {
        this.errorindex = 0;
        return false;
      }
      if (!this.accesspath) {
        this.errorindex = 1;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    checkTransaction(){
      if(!this.new_transaction.accountid){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.new_transaction.itemdesc){
        this.haserrors = true;
        this.errorindex = 12;
        return false;
      }
      if(!this.new_transaction.itemamount){
        this.haserrors = true;
        this.errorindex = 13;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    calculateAmount() {
      if(this.route==0)this.new_transaction.itemamount = this.new_transaction.itemquantity * this.new_transaction.itemprice;
      else if(this.route==1)this.edit_transaction.itemamount = this.edit_transaction.itemquantity * this.edit_transaction.itemprice;
      this.itemamount = this.edit_transaction.itemamount;  
    },
    clearTransaction() {
      this.edit_transaction = {};
      this.new_transaction = {};
    },
    deleteTransactionDialog(item) {
      this.isDeleteTransaction = true;
      this.delete_transaction = {_id: item._id, itemname: item.itemname, itemdesc: item.itemdesc};
    },
    deleteFileDialog(item) {
      this.isDeleteFile = true;
      this.deletefile = {_id: item._id,filename: item.filename,};
    },
    async deleteFile(payload) {
      this.isDeleteFile = false;
      let response = await this.deleteFileRequest(payload);
      let index = this.files.findIndex((trans) => trans._id == response._id);
      this.files.splice(index, 1);
    },
    async deleteTransaction(payload) {
      this.isDeleteTransaction = false;
      let response = await this.deleteBillTransactionRequest(payload);
      let index = this.transactions.findIndex((trans) => trans._id == response._id);
      this.transactions.splice(index, 1);
      this.getBillRequest(this.initvalue._id);
    },
    async insertTransaction() {
      if(!this.checkTransaction()) return;
      let payload = Object.assign({billid: this.initvalue._id}, this.new_transaction);
      console.log(this.new_transaction)
      let response = await this.insertBillTransactionRequest(payload);
      this.transactions.push(response);
      this.getBillRequest(this.initvalue._id);
      this.clearTransaction();
      this.isAddTransaction = false;
    },
    editTransactionDialog(item) {
      this.isEditTransaction = true;
      let account = this.accounts.find(account=>account._id == item.accountid);
      this.accountclass2 = account.accountclass;
      this.accountsubclass2 = account.accountsubclass;
      this.edit_transaction = Object.assign({}, item);
      this.edit_transaction.transdate = formatStdDate(this.edit_transaction.transdate);
    },
    onChangeFile(file) {
      if (!file) this.upload.file = null;
      else this.upload.file = file;
    },
    onChangeBill(value, field) {
      this.change_bill[field] = value;
    },



    searchVendorDialog(){
      this.searchvendor = {};
      this.isSearchVendor = true;
    },
  
    async updateBill() {
      this.change_bill._id = this.initvalue._id;
      await this.updateBillRequest(this.change_bill);
      router.push("/bill/list");
    },
    async updateTransaction() {
      this.isEditTransaction = false;
      let response = await this.updateBillTransaction(this.edit_transaction);
      let index = this.transactions.findIndex((x) => x._id == response._id);
      this.transactions.splice(index, 1, response);
      this.clearTransaction();
      this.getBillRequest(this.initvalue._id);
    },
    async uploadFile(){
      this.isUploadFile = false;
      this.upload.id = this.initvalue._id;
      this.upload.route = 'bill';
      let file = await this.insertRouteFile(this.upload);
      this.files.push(file);
      this.upload = {filename: null,file: null};
      this.getBillsRequest(this.initvalue._id);
    },
  },

  async created() {
    this.initvalue = this.$route.params;
    if (!this.initvalue._id) this.$router.push({ name: "BillList" });
    
    this.edit_bill = Object.assign({}, this.initvalue);
    this.billdate = formatStdDate(this.initvalue.billdate);
    this.billduedate = formatStdDate(this.initvalue.billduedate);
    
    let result = await this.getBillRequest(this.initvalue._id);
    if (this.locations.length==0) await this.getLocationsRequest();
    if (this.departments.length==0) await this.getDepartmentsRequest();
    if (this.saleschannels.length==0) await this.getSalesChannelsRequest();
    if (this.properties.length==0) await this.getPropertiesRequest();
    if (this.regions.length==0) await this.getRegionsRequest();
    if (this.accounts.length==0) await this.getAccountsRequest();

    this.transactions = Object.assign([], result.transactions);
    this.files = Object.assign([], result.files);
    this.images = Object.assign([], result.images);

    this.isRental = await this.getSetting({code: 'CompanySettings', name: 'isRental'}, );
    this.isRental==true ? this.type='rental' : this.type='service';
  },
};
</script>

<style src="./Edit.scss" lang="scss"></style>
